export const ADD_CHAT_GROUP_FIELDS = {
  GROUP_NAME: "groupName",
  USER_NAME: "userName",
};
